import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';
import { GfTitleService } from '../../../services/core.title.service';
import { UserService } from '../../../services/core.user.service';
import { StateHelperService } from '../../../services/core.ui.state.service';

@Component({
  selector: 'gf-login',
  template: require('./login.component.html')
})
export class LoginComponent implements OnInit {
  @Input() registrationMode;
  @Input() authMethods;

  username: string = '';
  password: string = '';
  login: boolean = false;

  constructor(
    private stateService: StateService,
    private translateService: GfTranslateService,
    private uiService: UiService,
    private userService: UserService,
    private stateHelperService: StateHelperService,
    private titleService: GfTitleService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Log In');
    this.uiService.setFocus('loginUnixName');
  }

  postLogin(): void {
    this.login = true;
    this.userService.session
      .login(this.username, this.password)
      .then((response) => this.handleLoginResponse(response))
      .catch((response) => this.handleLoginResponse(response));
  }

  private handleLoginResponse(response: any): void {
    const msgTitle = this.translateService.translate('Welcome');
    const msgSuccess = this.translateService.translate('Logged in successfully');

    if (response.success) {
      this.uiService.message.showSuccess(msgSuccess, msgTitle);
      this.userService.preference.init().then(() => this.sendToUserPage());
    } else if (response.status === 400) {
      if (response.message?.status === 'password-expired') {
        const msgErrorTitle = this.translateService.translate('Password expired');
        const msgErrorDesc = this.translateService.translate(
          'Your password has expired, please enter a new one'
        );
        this.uiService.message.showError(msgErrorDesc, msgErrorTitle);
        this.stateService.go('home.user.changepassword', { unixName: this.username });
      } else if (response.message?.status === 'locked-out') {
        const msgErrorTitle = this.translateService.translate('Your user is locked out');
        const msgErrorDesc = this.translateService.translate(
          'You had too many login attempts and your account has been locked. A password reset request email has been issued to your registered email account, please follow the link provided or contact your administrator.'
        );
        this.uiService.message.showError(msgErrorDesc, msgErrorTitle);
      }
    } else if (response.message?.title && response.message?.description) {
      const msgErrorTitle = this.translateService.translate(response.message.title);
      const msgErrorDesc = this.translateService.translate(response.message.description);
      this.uiService.message.showError(msgErrorDesc, msgErrorTitle);
    } else {
      const msgErrorTitle = this.translateService.translate('Login Failed');
      const msgErrorDesc = this.translateService.translate(
        'Sorry, the username or password you entered are invalid'
      );
      this.uiService.message.showError(msgErrorDesc, msgErrorTitle);
    }
    this.login = false;
  }

  private sendToUserPage(): void {
    if (!this.userService.session.hasUser()) return;

    // Same return-URL handling the `sessionRedirect` resolve uses when the session was
    // already valid on arrival — see core.user.routes.ts.
    if (this.stateHelperService.navigateByReturnUrl(this.stateService.params.url)) return;

    const next: any = this.userService.options.getLogonDestinationState();
    this.stateService.go(next.name, next.params, {notify: true, reload: true});
  }
}
